import httpClient from './httpClient'

export default {
  CountryCode: {
    GetAllCountryCodes(payload) {
      return httpClient.post('CountryCode/GetAllCountryCodes', payload)
    },
  },
}
